import { render, staticRenderFns } from "./BookmarkButton.vue?vue&type=template&id=923df238"
import script from "./BookmarkButton.vue?vue&type=script&lang=ts"
export * from "./BookmarkButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports